import { Box, Button, Stack, Text } from "@storyofams/react-ui";
import { CustomCheckbox } from "~components/common/CustomCheckbox";
import { useRecipeCart } from "./CartProvider";

export const ToolItem = ({ product }) => {
  const { toolsToCart, setTools } = useRecipeCart();
  const handleAddToCart = () => {
    if (toolsToCart.includes(product.id))
      setTools([...toolsToCart.filter((item) => item !== product.id)]);
    else setTools([...toolsToCart, product.id]);
  };
  return (
    <Box
      p={["8px", "8.3px 8px"]}
      width={"100%"}
      borderTop={"1px solid #E2DFDF"}
      position={"relative"}
      overflow={"visible"}
    >
      <Box
        width={"100%"}
        display={"flex"}
        alignItems={"flex-start"}
        justifyContent={"space-between"}
      >
        <Box display={"flex"}>
          <Box
            border={"1px solid #E2DFDF"}
            onClick={handleAddToCart}
            backgroundColor={!product.availableForSale && "#E2DFDF"}
            width={20}
            borderRadius={"3px"}
            overflow={"hidden"}
            cursor={"pointer"}
            height={20}
            mr={["6px", "10px"]}
            flexShrink={0}
          >
            {product.availableForSale && (
              <CustomCheckbox checked={toolsToCart.includes(product.id)} />
            )}
          </Box>
          <Text
            fontWeight={500}
            color={"#1D1D1B"}
            fontSize={["14px", "16px"]}
            lineHeight={["19.6px", "22.4px"]}
            textAlign={"end"}
            mr={["6px", "10px"]}
            width={["34px", "40px"]}
            flexShrink={0}
            pr="7px"
          >
            1x
          </Text>
          <Box>
            <Button as="a" target="_blank" href={`/products/${product.handle}`}>
              <Text
                fontWeight={500}
                color={"#1D1D1B"}
                fontSize={["14px", "16px"]}
                lineHeight={["19.6px", "22.4px"]}
                opacity={!product.availableForSale && 0.5}
                textAlign={"start"}
                mr={"10px"}
                minWidth={"40px"}
                css={{
                  "&:hover": { cursor: "pointer", textDecoration: "underline" },
                }}
              >
                {product.title}
              </Text>
            </Button>
            {!product.availableForSale && (
              <Box
                bg={"#EEE3D7"}
                mr={"10px"}
                mt={1}
                display={["block", "none"]}
                borderRadius="md"
                border={"1px solid grey200"}
                px="5px"
                width="86px"
                height={"17px"}
                position={"relative"}
              >
                <Text
                  position={"absolute"}
                  as="span"
                  fontSize={"10px"}
                  top={"1px"}
                  fontWeight={700}
                  letterSpacing={"0.1em"}
                  css={{ textTransform: "uppercase" }}
                >
                  Uitverkocht
                </Text>
              </Box>
            )}
          </Box>
        </Box>
        <Box display={"flex"} alignItems={"center"} flexShrink={0}>
          {!product.availableForSale && (
            <Box
              bg={"#EEE3D7"}
              mr={"10px"}
              display={["none", "block"]}
              borderRadius="md"
              border={"1px solid grey200"}
              px="5px"
              width="86px"
              height={"17px"}
              position={"relative"}
            >
              <Text
                position={"absolute"}
                as="span"
                fontSize={"10px"}
                top={"1px"}
                fontWeight={700}
                letterSpacing={"0.1em"}
                css={{ textTransform: "uppercase" }}
              >
                Uitverkocht
              </Text>
            </Box>
          )}
          {product?.variantTitle ? (
            <Stack space={1} alignItems={"center"}>
              <Text color="#767473" fontSize={"12px"} lineHeight={"16.8px"}>
                {product?.variantTitle}
              </Text>
              <Text
                opacity={0.7}
                color="#767473"
                fontSize={"18px"}
                lineHeight={"16.8px"}
              >
                •
              </Text>
              <Text
                color="#1D1D1B"
                fontSize={["14px", "16px"]}
                lineHeight={["19.6px", "22.4px"]}
              >
                {"€" + product.price}
              </Text>
            </Stack>
          ) : (
            <Text
              color="#1D1D1B"
              fontSize={["14px", "16px"]}
              lineHeight={["19.6px", "22.4px"]}
            >
              {"€" + product.price}
            </Text>
          )}
        </Box>
      </Box>
    </Box>
  );
};
